import React from 'react';
import { RoleTable } from '../../Components/Roles/RoleTable';

export const RolesScreen = () => {
  return (
    <div className="role-screen">
      <RoleTable />
    </div>
  );
};
